import httpClient from "../axiosBase/axiosHandler";

export const startOfflineSync = () => {
  return httpClient.post("/frontend-sync/start-sync/", {});
};

export const getOfflineSyncStatus = (id) => {
  return httpClient.get(`/frontend-sync/${id}/sync-log/`);
};

export const getOfflineActiveSync = () => {
  return httpClient.get("/frontend-sync/active-sync/");
};
